import "./Col.scss"
import React from 'react'

interface ColProps {
    children: React.ReactNode
    className?: string
    height?: number | string
    width?: string
    justifyContent?: "end" | "center" | "start"
    grow?: number
    gap?: "0" | "0.5" | "1"
}

export const Col: React.FC<ColProps> = (props) => {
    return (
        <div className={`col ${props.className ? props.className : ''}`}
            style={{
                flexGrow: props.grow ?? 1,
                height: props.height ?? 'auto',
                width: props.width ?? 'auto',
                justifyContent: props.justifyContent || 'start',
                gap: props.gap && `${props.gap}rem`
            } as React.CSSProperties}>
            {props.children}
        </div>
    );
};
